import * as tslib_1 from "tslib";
import { env } from '@ivy/fts/envInfo/envInfo';
import { Component, Vue, Prop } from 'vue-property-decorator';
import * as goodsApi from '@/api/goods';
import { uuid } from '@ivy/fts/utils';
import * as helper from '@/helper';
import { uploadEvent } from '@/api/goods/statistics';
let CartFooter = class CartFooter extends Vue {
    constructor() {
        super(...arguments);
        this.show = false;
    }
    get uploadEvent() {
        return uploadEvent;
    }
    get isAllChecked() {
        return (this.cartData &&
            this.cartData.product_info &&
            !this.cartData.product_info.some(el => !el.is_check && el.is_sale && el.stock_status && el.sku_status));
    }
    get totalNum() {
        return ((this.cartData &&
            this.cartData.product_info &&
            this.cartData.product_info.reduce((t, e) => {
                if (e.is_check && e.sku_status && e.stock_status && e.is_sale) {
                    return t + +e.num;
                }
                else
                    return t;
            }, 0)) ||
            0);
    }
    get isApp() {
        return env.type === 'ivydad' || env.type === 'web';
    }
    mounted() {
        this.show = true;
    }
    async checkAll() {
        let type = this.isAllChecked ? 6 : 5;
        const { data: { data: cartData }, } = await goodsApi.saveCart({
            type,
        });
        this.$emit('updateData', cartData);
    }
    showDiscountPop() {
        this.$emit('showDiscountPop');
    }
    async toConfirm() {
        await env.init();
        if (this.isApp) {
            // 判断App版本，若小于4.2.1则不支持
            let info = (await env.getInfo()) || {};
            let publicParams = info.publicParams || {};
            let version = publicParams.version;
            if (!version)
                return;
            let isAppLt421 = helper.compareVersion(version, '4.2.1', '<');
            if (isAppLt421) {
                return this.$Toast('当前版本暂不支持购物车结算～');
            }
        }
        if (!this.cartData || !this.cartData.product_info)
            return;
        let checkedList = (this.cartData &&
            this.cartData.product_info.filter(el => el.is_check && el.is_sale && el.sku_status && el.stock_status)) ||
            [];
        // 电商埋点-购物车点击结算
        await this.uploadEvent.sendRecord('Click_ShoppingCart_Settlement', '', checkedList.reduce((t, c, i) => {
            t.SkuID = t.SkuID += i === 0 ? `${c.sku_id}` : `_${c.sku_id}`;
            // SkuType 商品状态 购物车中能选的都是能正常售卖的 没必要埋
            return t;
        }, { SkuID: '', SkuType: '' }), [
            ['p1', 'SkuID'],
            ['p2', 'SkuType'],
        ]);
        if (!this.cartData || !this.cartData.product_info)
            return;
        let confirmInfo = checkedList.map(el => {
            return {
                sku_id: el.sku_id,
                num: el.num,
                type: el.scope,
                activity_info: Object.keys(el.activity_info).reduce((t, e) => {
                    return {
                        ...t,
                        [e]: el.activity_info[e].activity_id
                            ? { activity_id: el.activity_info[e].activity_id }
                            : {},
                    };
                }, {}),
            };
        });
        if (confirmInfo && confirmInfo.length > 0) {
            if (this.isApp) {
                let info = {
                    confirmInfo: confirmInfo,
                };
                await env.openOrderConfirm(info);
            }
            else {
                const confirmId = uuid();
                try {
                    window.sessionStorage.setItem(`confirm_id_${confirmId}`, JSON.stringify(confirmInfo));
                }
                catch (e) {
                    return this.$Toast('订单提交失败, 请检查当前是否处于无痕模式');
                }
                this.$router.push({
                    path: '/orderConfirm',
                    query: {
                        isCart: 'true',
                        confirmId: confirmId,
                    },
                });
            }
        }
        else {
            this.$Toast('您还没有选择的商品哦');
        }
    }
};
tslib_1.__decorate([
    Prop()
], CartFooter.prototype, "cartData", void 0);
tslib_1.__decorate([
    Prop()
], CartFooter.prototype, "isVip", void 0);
CartFooter = tslib_1.__decorate([
    Component({
        filters: {
            number2Fixed: num => {
                const number = +num;
                return number ? `${number.toFixed(2)}` : '0.00';
            },
        },
    })
], CartFooter);
export default CartFooter;
